import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
//import VueJwtDecode from "vue-jwt-decode"

const httpRefresh = axios.create({
  withCredentials: false,
  headers: {
    Accept: 'application/json',

  },
})

axios.interceptors.request.use(async (config) => {
  // eslint-disable-next-line no-param-reassign
  config.headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...config.headers,
  }
  if (localStorage.access_token) {
    if (config.url.indexOf(process.env.VUE_APP_API) === 0) {

      //let tokenData = VueJwtDecode.decode(localStorage.access_token)
      let exp = localStorage.access_expires
      let dateNow = Math.floor(Date.now() / 1000)

      if (exp < (dateNow - (60 * 30))) {
        const {data} = await httpRefresh.get(`${process.env.VUE_APP_AUTH}/api/v1/user/auth/token/?refresh_token=${localStorage.refresh_token}`, {
          headers: {
            'Accept-Language': 'ru'
          }
        })
        localStorage.access_token = data.item.access_token
        localStorage.refresh_token = data.item.refresh_token
        localStorage.access_expires = data.item.access_expires
        localStorage.refresh_expires = data.item.refresh_expires
      }

      if (exp < (dateNow - (60 * 30))) {
        try {
          await httpRefresh.get(`${process.env.VUE_APP_AUTH}/api/v1/user/auth/checklink`, {
            headers: {
              'token': localStorage.access_token,
              'Accept-Language': 'ru'
            }
          }).then(() => {
          }).catch(function (error) {
            if (error.response && error.response.status == 401 || error.response && error.response.status == 499) {
              localStorage.removeItem('access_token');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('access_expires');
              localStorage.removeItem('refresh_expires');
              localStorage.removeItem('isOpenMenu');
              window.location.href = '/login';
            }
            if (error.response && error.response.status == 498) {
              const {data} = httpRefresh.get(`${process.env.VUE_APP_AUTH}/api/v1/user/auth/token/?refresh_token=${localStorage.refresh_token}`, {
                headers: {
                  'Accept-Language': 'ru'
                }
              })
              localStorage.access_token = data.item.access_token
              localStorage.refresh_token = data.item.refresh_token
              localStorage.access_expires = data.item.access_expires
              localStorage.refresh_expires = data.item.refresh_expires
            }
          });
        } catch (e) {
          console.log('e')
        }
      }

      if (config.url.indexOf(process.env.VUE_APP_API) === 0 || config.url.indexOf(process.env.VUE_APP_AUTH) === 0) {
        config.headers.Authorization = `Bearer ${localStorage.access_token}`
      }
    }
  }

  return config
}, (error) => {
  console.error(error.status)
  return Promise.reject(error)
})

// Function that will be called to refresh authorization
const refreshAuthLogic = failedRequest => axios.get(`${process.env.VUE_APP_AUTH}/api/v1/user/auth/token/?refresh_token=${localStorage.refresh_token}`).then(tokenRefreshResponse => {
        localStorage.access_token = tokenRefreshResponse.data.item.access_token
        localStorage.refresh_token = tokenRefreshResponse.data.item.refresh_token
        localStorage.access_expires = tokenRefreshResponse.data.item.access_expires
        localStorage.refresh_expires = tokenRefreshResponse.data.item.refresh_expires

  failedRequest.response.config.headers['token'] = localStorage.access_token
  failedRequest.response.config.headers['Accept-Language'] = 'ru'
  return Promise.resolve()
})

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic)


axios.interceptors.response.use(
  response => {
    return response
  },
  (error) => {
    if (error && error.response) {
      return Promise.reject(error.response)
    }
  }
)


export {
  axios
}
